import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import clsx from 'clsx';

interface SideMenuButtonAttributes {
  name: string;
  link: string;
  paths?: string[];
  isDisabled: boolean;
  isInvisible?: boolean;
  icon?: string;
}

interface SideMenuButtonProps {
  sideMenuButtonAttributes: SideMenuButtonAttributes;
  showMenu: boolean;
}

export const SideMenuButton: React.FC<SideMenuButtonProps> = ({
  sideMenuButtonAttributes,
  showMenu,
}) => {
  const location = useLocation();

  return (
    <div
      className={clsx(
        'flex flex-row justify-start rounded-[8px] pl-[8px]',
        showMenu ? 'w-[180px]' : 'w-auto',
        sideMenuButtonAttributes.isDisabled && 'pointer-events-none opacity-50',
        (location.pathname.includes(sideMenuButtonAttributes.link) ||
          sideMenuButtonAttributes.paths?.includes(location.pathname)) &&
          'bg-[#DCDCDC80]'
      )}
    >
      <Link
        to={sideMenuButtonAttributes.link}
        className="font-inter flex items-center justify-center pb-[6px] pt-2 text-[15px] text-black no-underline"
      >
        <img
          className="min-w-[24px]"
          alt={sideMenuButtonAttributes.name}
          src={sideMenuButtonAttributes.icon}
        />

        {showMenu && <span className="pl-2">{sideMenuButtonAttributes.name}</span>}
      </Link>
    </div>
  );
};
